import React from "react";
import ReactDOM from "react-dom";
import Flickity from "flickity";
import "flickity/dist/flickity.min.css";

export default class Slider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      flickityReady: false,
    };

    this.defaultOptions = {
      selectedAttraction: 0.075,
      friction: 0.375,
      contain: true,
      wrapAround: false,
      autoPlay: false,
      cellAlign: "left",
      pageDots: false,
      prevNextButtons: false,
      freeScroll: false,
      groupCells: true,
      imagesLoaded: true,
      on: {
        dragStart: function () {
          document.ontouchmove = function (e) {
            e.preventDefault();
          };
        },
        dragEnd: function () {
          document.ontouchmove = function (e) {
            return true;
          };
        },
      },
    };

    this.refreshFlickity = this.refreshFlickity.bind(this);
  }

  componentDidMount() {
    this.options = { ...this.defaultOptions, ...this.props.options };
    this.flickity = new Flickity(this.flickityNode, this.options || {});

    if (this.props.viewportClassName)
      this.flickity.viewport.className += " " + this.props.viewportClassName;
    if (this.props.innerClassName)
      this.flickity.slider.className += " " + this.props.innerClassName;

    this.setState({
      flickityReady: true,
    });
  }

  refreshFlickity() {
    this.flickity.reloadCells();
    this.flickity.resize();
    this.flickity.updateDraggable();
  }

  componentWillUnmount() {
    this.flickity.destroy();
  }

  componentDidUpdate(prevProps, prevState) {
    const flickityDidBecomeActive =
      !prevState.flickityReady && this.state.flickityReady;
    const childrenDidChange =
      prevProps.children.length !== this.props.children.length;

    if (flickityDidBecomeActive || childrenDidChange) {
      this.refreshFlickity();
    }
  }

  renderPortal() {
    if (!this.flickityNode) {
      return null;
    }

    const mountNode = this.flickityNode.querySelector(".flickity-slider");

    if (mountNode) {
      const children = [
        // <div className={this.props.spacerClassName} key="prepend" />,
        ...this.props.children,
        // <div className="w-4" key="append" />
      ];
      return ReactDOM.createPortal(children, mountNode);
    }
  }

  render() {
    let classNames = this.props.className;
    classNames += "";

    return [
      <div
        className={classNames}
        key="flickityBase"
        ref={(node) => (this.flickityNode = node)}
      />,
      this.renderPortal(),
    ].filter(Boolean);
  }
}
